import { AppBar, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import { useState } from "react";
import { AccountCircle } from "@mui/icons-material";
import Box from '@mui/material/Box';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuthentication } from "../hooks/useAuthentication";

const Navigation = ({ property, title, logoUrl }) => {
    const { isAuthenticated, authenticatedUser, logout } = useAuthentication();

    // Use property (when passed from parent) or fall back to title/logoUrl props
    const displayLogoUrl = property?.logoUrl || logoUrl;
    const displayTitle = property?.name || title;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleAccountClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleAccountClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        logout();
    }

    return <><AppBar position="static" color="primary">
        <Toolbar>
            {displayLogoUrl && <img src={displayLogoUrl} alt="Logo" style={{ height: 40, marginRight: 24, backgroundColor: 'white' }} />}
            {displayTitle && <Typography
                variant="h6"
                noWrap
                component="div"
            >
                {displayTitle}
            </Typography>}
            {isAuthenticated && <><Box sx={{ flexGrow: 1 }} />
                <Box>
                    <IconButton
                        size="large"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={"account-menu"}
                        aria-haspopup="true"
                        color="inherit"
                        onClick={handleAccountClick}
                    >
                        <AccountCircle />
                    </IconButton>
                    <Menu
                        id="account-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleAccountClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        sx={{
                            '& .MuiMenu-paper': {
                                minWidth: '250px',
                            }
                        }}
                    >
                        <MenuItem><ListItemIcon><AccountCircle /></ListItemIcon><ListItemText>{authenticatedUser?.name}</ListItemText></MenuItem>
                        <Divider />
                        <MenuItem onClick={handleLogout}><ListItemIcon><LogoutIcon /></ListItemIcon><ListItemText>Logout</ListItemText></MenuItem>
                    </Menu>
                </Box></>}
        </Toolbar>
    </AppBar>
    </>;
}

export default Navigation;